import { Fragments } from "requests";

export const getDefaultValues = (
  generalAssessment: Fragments.StoredGeneralAssessment
) => ({
  beforePhotoFront: generalAssessment?.beforePhotoFront || null,
  beforePhotoLeft: generalAssessment?.beforePhotoLeft || null,
  beforePhotoRight: generalAssessment?.beforePhotoRight || null,
  afterPhotoFront: generalAssessment?.afterPhotoFront || null,
  afterPhotoLeft: generalAssessment?.afterPhotoLeft || null,
  afterPhotoRight: generalAssessment?.afterPhotoRight || null,
  additionalPhotos: generalAssessment?.additionalPhotos || [],
  radiographicFindingsPhotos:
    generalAssessment?.radiographicFindingsPhotos || []
});
